import {HomeIntro} from "./Home/Intro";
import {ToutSavoir} from "./Home/ToutSavoir";
import {Foire} from "./Home/Foire";
import {Partenaires} from "./Home/Partenaires";

export const Home = ({
                         openDownloadModal
                     }) => {

    return (
        <>
            <main>
                <HomeIntro openDownloadModal={openDownloadModal} />
                <ToutSavoir />
                <Foire />
                <Partenaires />
            </main>
        </>
    )
}